import { Page } from 'framework7-react';
import { FC, useState } from 'react';
import Calendar, { CalendarProps } from 'react-calendar';
import { useFormContext } from 'react-hook-form';
import { PopupTemplate } from '@/components/uiParts/Template/PopupTemplate/PopupTemplate';
import { DATE_MONTH_INCREMENTER, formatDateWithDay } from '@/utils/date';

interface SelectCalendarProps extends CalendarProps {
  name: string;
  value: Date;
  onChange: (value: Date) => void;
}

type DateClass = { date: Date };

export const SelectCalendar: FC<SelectCalendarProps> = (props) => {
  const { name, value, onChange, ...calendarProps } = props;
  const { register } = useFormContext();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentView, setCurrentView] = useState<
    'month' | 'year' | 'decade' | 'century' | null
  >(null);

  const clickDay = (value: Date) => {
    setIsModalOpen(false);
    onChange(value);
  };

  const valueFormat = value
    ? formatDateWithDay(new Date(value) || Date.now())
    : '';

  const prevLabel = currentView === 'year' ? '＜ 前年' : '＜ 前月';
  const nextLabel = currentView === 'year' ? '次年 ＞' : '次月 ＞';

  return (
    <>
      <div className="input-calendar" onClick={() => setIsModalOpen(true)}>
        <input type="text" name={name} value={valueFormat} readOnly />
      </div>

      <PopupTemplate
        id={`SelectCalendar-${name}`}
        title=""
        opened={isModalOpen}
        handleClose={() => setIsModalOpen(false)}
      >
        <Page name="deliveryCalendarPopUp">
          <Calendar
            prev2Label={null}
            next2Label={null}
            value={value || null}
            onClickDay={clickDay}
            minDetail={'month'}
            nextLabel={nextLabel}
            prevLabel={prevLabel}
            navigationLabel={({ date }: DateClass) => {
              const year = date.getFullYear();
              const month = date.getMonth() + DATE_MONTH_INCREMENTER;
              return `${year}年${month}月`;
            }}
            formatShortWeekday={(locale, date) => {
              const day = date.getDay();
              const weekday = ['日', '月', '火', '水', '木', '金', '土'];
              return weekday[day];
            }}
            onViewChange={({ view }) => setCurrentView(view)}
            formatDay={(_, date) => String(date.getDate())}
            {...calendarProps}
          />
        </Page>
      </PopupTemplate>
    </>
  );
};
